<div class="sheet-page">
  <div class="container-xxl sheet">
    <header class="sheet-head">
      <p class="sheet-kicker">Archivio storico</p>
      <div class="sheet-title-row">
        <button class="sheet-back" type="button" aria-label="Indietro" (click)="goBack()">
          <i class="bi bi-arrow-left" aria-hidden="true"></i>
          <span class="back-label">Indietro</span>
        </button>
        <span class="sheet-divider" aria-hidden="true"></span>
        <h1>{{ article?.title }}</h1>
        @if (article?.code) {
          <p class="sheet-code"><span>Codice:</span> {{ article?.code }}{{ article?.progressive }}</p>
        }
      </div>
    </header>

    <div class="sheet-layout">
      <div class="sheet-media">
      <section class="sheet-gallery" aria-label="File della scheda">
        @if (files.length > 0) {
          @let file = files[currentImg];
          <div class="gallery-stage">
            @if (file.ext != 'pdf' && file.ext != 'mp4' && file.ext != 'youtube') {
              <button class="gallery-frame" type="button" (click)="openFullscreenModal(file)"
                [attr.aria-label]="'Apri ' + (file.title || article?.title || 'immagine') + ' a schermo intero'">
                <img [src]="urlServerLaraApiMultimedia + file.src" [alt]="file.title || article?.title || ''"
                  (contextmenu)="$event.preventDefault()">
              </button>
            }
            @if (file.ext == 'pdf') {
              <button class="gallery-frame" type="button" (click)="openFullscreenModal(file)"
                [attr.aria-label]="'Apri ' + (file.title || 'PDF') + ' a schermo intero'">
                <img class="is-document" [src]="thumbnails[file.src] || 'assets/img/pdfCover.png'"
                  [alt]="file.title || 'Documento PDF'">
              </button>
            }
            @if (file.ext == 'mp4') {
              <video class="gallery-video" controls>
                <source [src]="urlServerLaraApiMultimedia + file.src" type="video/mp4">
              </video>
            }
            @if (file.ext == 'youtube') {
              <iframe class="gallery-video" [src]="file.sanitized_url" [title]="file.title || article?.title || 'Video'"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen>
              </iframe>
            }

            @if (files.length > 1) {
              <button class="gallery-nav gallery-nav-prev" type="button" (click)="prevImg()" aria-label="File precedente">
                <i class="bi bi-chevron-left" aria-hidden="true"></i>
              </button>
              <button class="gallery-nav gallery-nav-next" type="button" (click)="nextImg()" aria-label="File successivo">
                <i class="bi bi-chevron-right" aria-hidden="true"></i>
              </button>
            }
          </div>

          @if (files.length > 1) {
            <div class="gallery-thumbs" role="tablist" aria-label="Anteprime">
              @for (img of files; track img.id; let i = $index) {
                <button #thumb class="gallery-thumb" type="button" role="tab" [class.is-active]="i === currentImg"
                  [attr.aria-selected]="i === currentImg" [attr.aria-label]="img.title || 'File ' + (i + 1)"
                  (click)="goToImg(i)">
                  @if (img.ext != 'pdf' && img.ext != 'mp4' && img.ext != 'youtube') {
                    <img [src]="urlServerLaraApiMultimedia + img.src" [alt]="img.title || ''"
                      (contextmenu)="$event.preventDefault()">
                  }
                  @if (img.ext == 'pdf') {
                    <img class="is-document" [src]="thumbnails[img.src] || 'assets/img/pdfCover.png'"
                      [alt]="img.title || 'PDF'">
                  }
                  @if (img.ext == 'mp4' || img.ext == 'youtube') {
                    <img [src]="urlServerLaraApiMultimedia + img.src_placeholder" [alt]="img.title || 'Video'">
                  }
                </button>
              }
            </div>
          }
        } @else if (filesLoaded) {
          <p class="gallery-empty">Nessun file associato a questa scheda.</p>
        } @else {
          <div class="gallery-stage gallery-pending" aria-hidden="true"></div>
        }
      </section>

      @if (authService.isLoggedIn() && article) {
        <div class="sheet-actions">
          <a class="sheet-edit" [routerLink]="['/modificaSchedaStorica', article.id]">
            <i class="bi bi-pencil" aria-hidden="true"></i>
            Modifica scheda
          </a>
          <button class="sheet-delete" type="button" (click)="deleteArticle(article.id)">
            <i class="bi bi-trash" aria-hidden="true"></i>
            Elimina
          </button>
        </div>
      }
      </div>

      <aside class="sheet-side">
        <section class="sheet-panel">
          <h2><i class="bi bi-info-circle-fill" aria-hidden="true"></i>Dati scheda</h2>
          <dl class="sheet-facts">
            @if (article?.title) {
              <div>
                <dt>Titolo</dt>
                <dd>{{ article?.title }}</dd>
              </div>
            }
            @if (article?.category?.title) {
              <div>
                <dt>Categoria</dt>
                <dd>{{ article?.category?.title }}</dd>
              </div>
            }
            @if (article?.subcategory) {
              <div>
                <dt>Sottocategoria</dt>
                <dd>{{ article?.subcategory?.title }}</dd>
              </div>
            }
            @if (article?.date_type === 0 && article?.date_article) {
              <div>
                <dt>Data</dt>
                <dd>{{ article?.date_article | date: 'dd/MM/yyyy' }}</dd>
              </div>
            }
            @if (article?.date_type === 1 && article?.year_article) {
              <div>
                <dt>Anno</dt>
                <dd>{{ article?.year_article }}</dd>
              </div>
            }
            @if (article?.date_type === 2 && (article?.yearfrom_article || article?.yearto_article)) {
              <div>
                <dt>Periodo</dt>
                <dd>da {{ article?.yearfrom_article }} a {{ article?.yearto_article }}</dd>
              </div>
            }
            @if (cityLabel(article?.city)) {
              <div>
                <dt>Città</dt>
                <dd>{{ cityLabel(article?.city) }}</dd>
              </div>
            }
            @if (article?.pointofinterest) {
              <div>
                <dt>Luogo di interesse</dt>
                <dd>{{ article?.pointofinterest }}</dd>
              </div>
            }
            @if (article?.storage_place) {
              <div>
                <dt>Luogo di conservazione</dt>
                <dd>{{ article?.storage_place }}</dd>
              </div>
            }
          </dl>

          @if (article && hasPlacement(article)) {
            <dl class="sheet-facts sheet-place row g-3">
              @if (article.floor) {
                <div class="col-6">
                  <dt>Piano</dt>
                  <dd>{{ article.floor }}</dd>
                </div>
              }
              @if (article.room) {
                <div class="col-6">
                  <dt>Stanza</dt>
                  <dd>{{ article.room }}</dd>
                </div>
              }
              @if (article.rack) {
                <div class="col-6">
                  <dt>Scaffale / armadio</dt>
                  <dd>{{ article.rack }}</dd>
                </div>
              }
              @if (article.case) {
                <div class="col-6">
                  <dt>Contenitore</dt>
                  <dd>{{ article.case }}</dd>
                </div>
              }
              @if (article.shelf) {
                <div class="col-6">
                  <dt>Ripiano</dt>
                  <dd>{{ article.shelf }}</dd>
                </div>
              }
            </dl>
          }
        </section>

        @if (article?.description) {
          <section class="sheet-panel">
            <h2><i class="bi bi-card-text" aria-hidden="true"></i>Descrizione</h2>
            <p class="sheet-description">{{ article?.description }}</p>
          </section>
        }
      </aside>
    </div>
  </div>
</div>
